import { buildErrorMessage } from '@constants'
import { AxiosError } from 'axios'
import { useQuery } from '@tanstack/react-query'
import { useSnackbar } from '@ui/snackbar'
import { useStiffeningStore } from '@editorStores'
import { getStiffeningIntervals } from '@queries'
import { usePersistentParams } from 'src/hooks'

/**
 * Loads the stiffening segments into the stiffening store for the stiffening plan preview, which
 * draws them (and derives their labels) from there. Refetched on every enter, like on the results
 * page, since the segments are edited in the structural planning.
 */
const useLoadStiffeningSegments = (enabled: boolean): void => {
  const { projectId } = usePersistentParams() as { projectId?: string }
  const { enqueueSnackbar } = useSnackbar()
  const setStiffeningIntervals = useStiffeningStore(state => state.setStiffeningIntervals)

  useQuery({
    queryKey: getStiffeningIntervals.getKey(projectId),
    queryFn: ({ signal }) => getStiffeningIntervals.request(projectId, signal),
    enabled: enabled && !!projectId,
    onSuccess: setStiffeningIntervals,
    onError: (error: AxiosError) =>
      enqueueSnackbar(buildErrorMessage(error, 'Fehler beim Laden der Aussteifenden Elemente'), {
        variant: 'error',
      }),
    // Overrides the client defaults (`staleTime: Infinity`, `refetchOnMount: false`), so switching
    // to the stiffening plan refetches too.
    staleTime: 0,
    refetchOnMount: 'always',
  })
}

export default useLoadStiffeningSegments
